import {createApp} from 'vue'
import { createPinia } from 'pinia'

import i18n from "@/plugins/i18n";

import 'tdesign-vue-next/es/style/index.css';
import './styles/admin-appearance.css';
import { syncAdminAppearanceFromStorage } from './utils/adminAppearanceDom.js';

syncAdminAppearanceFromStorage();

/**
 * App 与 router 都在 bootstrap 中动态加载，避免 main <-> router chunk 循环初始化时序问题。
 */
async function bootstrap() {
    const { default: App } = await import("@/App");
    const { default: router } = await import("@/router");
    const app = createApp(App);

    app.use(createPinia());

    app.use(router);
    app.use(i18n);

    app.mount('#app');
}

bootstrap().catch((err) => {
    console.error("[bootstrap] failed to mount app", err);
});




